"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAYMENT_REQUEST_STATUS_SUCCESS = exports.PAYMENT_REQUEST_STATUS_FAILURE = exports.PAYMENT_REQUEST_API_SESSION_START_ERR = exports.PAYMENT_REQUEST_API_ERR = exports.INVALID_API_TYPE = exports.APPLE_VALIDATION_ERR = exports.APPLE_REDUCER_ACTION_ERR = exports.APPLE_JS_API_SESSION_START_ERR = exports.APPLE_JS_API_ERR = exports.APPLE_AUTHORIZE_ERR = void 0;
/* eslint-disable max-len */
var APPLE_AUTHORIZE_ERR = 'APPLE PAY WALLET AUTHORIZATION FALIED';
exports.APPLE_AUTHORIZE_ERR = APPLE_AUTHORIZE_ERR;
var APPLE_VALIDATION_ERR = 'APPLE PAY MERCHANT VALIDATION FAILED';
exports.APPLE_VALIDATION_ERR = APPLE_VALIDATION_ERR;
var APPLE_JS_API_ERR = 'ERROR OCCURRED WHILE HANDLING APPLE PAY JS API';
exports.APPLE_JS_API_ERR = APPLE_JS_API_ERR;
var PAYMENT_REQUEST_API_ERR = ' ERROR OCCURRRED WHILE HANDLING PAYMENT REQUEST API';
exports.PAYMENT_REQUEST_API_ERR = PAYMENT_REQUEST_API_ERR;
var APPLE_JS_API_SESSION_START_ERR = 'UNABLE TO START APPLE PAY SESSION';
exports.APPLE_JS_API_SESSION_START_ERR = APPLE_JS_API_SESSION_START_ERR;
var PAYMENT_REQUEST_API_SESSION_START_ERR = 'UNABLE TO START PAYMENT REQUEST SESSION';
exports.PAYMENT_REQUEST_API_SESSION_START_ERR = PAYMENT_REQUEST_API_SESSION_START_ERR;
var INVALID_API_TYPE = "THE API TYPE IS NOT CORRECT, THE TYPE VALUE SHOULD BE \n'applePayJsAPI' OR 'paymentRequestAPI'";
exports.INVALID_API_TYPE = INVALID_API_TYPE;
var PAYMENT_REQUEST_STATUS_SUCCESS = 'success';
exports.PAYMENT_REQUEST_STATUS_SUCCESS = PAYMENT_REQUEST_STATUS_SUCCESS;
var PAYMENT_REQUEST_STATUS_FAILURE = 'fail';
exports.PAYMENT_REQUEST_STATUS_FAILURE = PAYMENT_REQUEST_STATUS_FAILURE;
var APPLE_REDUCER_ACTION_ERR = 'INVALID DISPATCH ACTION TYPE. THE ONLY ACTION TYPE TO BE USED IS "resetOptions"';
exports.APPLE_REDUCER_ACTION_ERR = APPLE_REDUCER_ACTION_ERR;